import { useCallback } from 'react'
import { useStore } from 'react-redux'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { type RootState } from '../../../store/store'
import {
  bumpCrossClientResultsRevision,
  selectCrossClientResultBucketsRevision,
  selectCrossClientResultsExecution,
  setCrossClientResultBuckets,
} from '../../../store/crossClient/crossClientResults'
import { useLazyGetCrossClientResultBucketsQuery } from '../../../store/crossClient/crossClient'

export interface CrossClientResultsRefresh {
  refreshAfterResultMutation: () => Promise<void>
}

export const useCrossClientResultsRefresh = (): CrossClientResultsRefresh => {
  const dispatch = useAppDispatch()
  const store = useStore<RootState>()

  const accountId = useAppSelector(selectAccountId)
  const execution = useAppSelector(selectCrossClientResultsExecution)

  const [triggerGetResultBuckets] = useLazyGetCrossClientResultBucketsQuery()

  const refreshAfterResultMutation = useCallback(async () => {
    if (!execution) {
      return
    }
    // First, so a failed count refresh can't keep the lists from showing the change.
    dispatch(bumpCrossClientResultsRevision())
    const bucketsRevision = selectCrossClientResultBucketsRevision(store.getState())
    const buckets = await triggerGetResultBuckets({ accountId, executionId: execution.id }).unwrap()
    dispatch(setCrossClientResultBuckets(buckets ?? [], bucketsRevision))
  }, [dispatch, store, accountId, execution, triggerGetResultBuckets])

  return { refreshAfterResultMutation }
}
